<template>
  <q-page class="container" padding>
    <PageHeader
      title="Assosiar Usuario / ferramenta"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div class="row col-3">
      <lista-unidades-select v-model="unidade"></lista-unidades-select>
    </div>
    <div class="row q-mt-md">
      <usuarios @selectValue="getUsuario" :atualizar="refresh" />
      <select-component-ferramenta-assosiacao
        class="q-mt-md"
        @ferramentasSelecionadas="getFerramentas"
        :atualizar="usuario"
      />
    </div>
    <q-tabs
      v-model="tab"
      dense
      class="text-grey bg-grey-3 q-mt-xl"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="selecionadas" label="Selecionadas" />
      <q-tab name="associadas" label="Associadas" />
    </q-tabs>
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="selecionadas">
        <div>
          <q-table
            flat
            table-header-class="bg-accent text-width-bold"
            class="q-mt-sm tabela-tamanho-fixo"
            :rows="ferramentasSelecionadas"
            :columns="columns"
            :loading="disable"
            dense
            :rows-per-page-options="[0]"
            hide-bottom
            row-key="id"
            no-data-label
          >
            <template v-slot:bottom>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">Ferramentas Selecionadas</p>
                </div>
              </section>
            </template>
            <template v-slot:top>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">
                    Ferramentas Selecionadas
                    <span v-if="usuario"
                      >- {{ usuario.name }} - {{ usuario.sap }} - ({{
                        usuario.email
                      }})</span
                    >
                  </p>
                </div>
              </section>
            </template>
            <template #body-cell-remover="props">
              <q-td>
                <q-btn
                  size="sm"
                  color="red"
                  icon="delete"
                  label="Remover"
                  no-caps
                  @click="remover(props)"
                />
              </q-td>
            </template>
          </q-table>
          <div class="row justify-end">
            <q-btn
              size="md"
              class="q-mt-lg"
              color="positive"
              label="Associar Ferramentas"
              no-caps
              @click="Assosiar(props)"
            />
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel name="associadas">
        <div>
          <q-table
            flat
            table-header-class="bg-accent text-width-bold"
            class="q-mt-sm tabela-tamanho-fixo"
            :rows="ferramentasVinculadas"
            :columns="columns2"
            dense
            :loading="disable"
            :rows-per-page-options="[0]"
            hide-bottom
            row-key="id"
            no-data-label
          >
            <template v-slot:top>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">
                    Ferramentas Associadas ao usuário:
                    <span v-if="usuario"
                      >- {{ usuario.name }} - {{ usuario.sap }} - ({{
                        usuario.email
                      }})</span
                    >
                  </p>
                </div>
              </section>
            </template>
            <template #body-cell-remover="props">
              <q-td>
                <q-btn
                  size="sm"
                  color="red"
                  icon="delete"
                  label="Remover Associação"
                  no-caps
                  @click="desvincular(props.row.ferramenta_uuid)"
                />
              </q-td>
            </template>
          </q-table>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },

  {
    name: "nome",
    label: "Ferramenta",
    field: (row) => row.nome,
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimonio",
    field: "patrimonio",
    align: "left",
  },
];

const columns2 = [
  {
    name: "nome_ferramenta",
    label: "Ferramenta",
    field: "nome_ferramenta",
    align: "left",
  },

  {
    name: "nome_vendor",
    label: "Unidade",
    field: "nome_vendor",
    align: "left",
  },
  {
    name: "status_ferramenta",
    label: "Status",
    field: "status_ferramenta",
    align: "left",
  },
  {
    name: "remover",
    label: "Desfazer Associação",
    field: "remover",
    align: "left",
  },
];

import Usuarios from "../components/TableUsuarios.vue";
import SelectComponentFerramentaAssosiacao from "../components/SelectComponentFerramentaAssosiacao.vue";
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    Usuarios,
    SelectComponentFerramentaAssosiacao,
    ListaUnidadesSelect,
    PageHeader,
  },
  setup() {
    const $q = useQuasar();
    const store = useStore();
    const usuario = ref("");
    const ferramentasSelecionadas = ref([]);
    const ferramentasVinculadas = ref([]);
    const refresh = ref(0);
    const tab = ref("selecionadas");
    let unidade = ref("");

    const getUsuario = async (value) => {
      if (value) usuario.value = await value[0];

      let resposta = await store.dispatch("fer/getUsuarioFerramentaVinculo", {
        user_id: usuario.value.id,
      });
      if (resposta.data.result[0] == undefined) {
        ferramentasVinculadas.value = [];
        return;
      }
      ferramentasVinculadas.value = resposta.data.result[0].ferramentas;
    };

    const getFerramentas = async (ferramenta) => {
      ferramentasSelecionadas.value = ferramenta;
    };

    const remover = async (dados) => {
      ferramentasSelecionadas.value.splice(dados.rowIndex, 1);
    };

    const desvincular = async (idFerramenta) => {
      try {
        await store.dispatch("fer/desvincularFerramenta", {
          idUsuario: usuario.value.id,
          idFerramenta: idFerramenta,
        });
        $q.notify({
          message: "Ferramenta Desvinculada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        let resposta = await store.dispatch("fer/getUsuarioFerramentaVinculo", {
          user_id: usuario.value.id,
        });
        if (resposta.data.result[0] == undefined) {
          ferramentasVinculadas.value = [];
          return;
        }
        ferramentasVinculadas.value = resposta.data.result[0].ferramentas;
      } catch (error) {
        $q.notify({
          message: "Erro a o desvincular ferramenta",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getUsuario();
      }
    };

    const Assosiar = async () => {
      try {
        let ferramentas = [];
        ferramentasSelecionadas.value.forEach((e) => {
          ferramentas.push({ uuid: e.uuid });
        });

        await store.dispatch("fer/assosiarFerramentas", {
          idUsuario: usuario.value.id,
          ferramentas,
        });

        $q.notify({
          message: "Ferramenta Assosiada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        while (ferramentasSelecionadas.value.length) {
          ferramentasSelecionadas.value.pop();
        }
        getUsuario();
        refresh.value++;
      } catch (error) {
        $q.notify({
          message: "Erro a o Assosiar ferramenta",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidadee = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
        refresh.value++;
      }
    );

    onMounted(getUnidadee);

    return {
      getUsuario,
      getFerramentas,
      ferramentasSelecionadas,
      columns,
      remover,
      usuario,
      ferramentasVinculadas,
      columns2,
      desvincular,
      unidade,
      Assosiar,
      refresh,
      tab,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
